import React, { ButtonHTMLAttributes, Fragment } from "react";

type ButtonSoftProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text?: string;
  size?: string;
};

export const ButtonSoft: React.FC<ButtonSoftProps> = ({
  size = "smallxs",
  text,
  ...props
}) => (
  <Fragment>
    <button
      {...props}
      type="button"
      className={`rounded bg-primary-50 ${
        size === "small"
          ? "px-2 py-1 text-sm"
          : size === "medium"
            ? "px-2.5 py-1.5 text-sm"
            : size === "large"
              ? "px-3 py-2 text-sm"
              : size === "extraLarge"
                ? "px-3.5 py-2.5 text-sm"
                : "px-2 py-1 text-xs"
      } font-semibold text-primary-600 shadow-sm hover:bg-primary-100`}
    >
      {text}
    </button>
  </Fragment>
);
